export const FONTSIZE_5 = "15px";

export const mainColor = "#E02F6B";

export const blueColor = "#0000FF";

export const blueDark = "#18293C";

export const orangeColor = "#FFA500";

export const greenYellowColor = "#cddc39";

export const pinkLight = "#EFA2B4";

export const cyanLight = "#aef1ee";

export const white = "#FFFFFF";

export const whiteAlpha40 = "rgba(255,255,255,0.40)";

export const whiteAlpha25 = "rgba(255,255,255,0.25)";

export const backDropFilter = "blur(5px)";
